import React, { useState, useRef, useEffect } from "react";
import setInputValue from "../../hooks/setInputValue";
import "./GeneralContact.sass";

export const GeneralContact = () => {
  // Anti-bot: Form load time
  const formLoadTime = useRef(Date.now());

  // Anti-bot: User interaction detection
  const [hasInteracted, setHasInteracted] = useState(false);

  // Form fields
  const name = setInputValue("");
  const email = setInputValue("");
  const phone = setInputValue("");
  const message = setInputValue("");

  // Anti-bot: Honeypot field
  const website = setInputValue("");

  // Anti-bot: Detect human interaction
  useEffect(() => {
    const handleInteraction = () => setHasInteracted(true);

    window.addEventListener('mousemove', handleInteraction, { once: true });
    window.addEventListener('keydown', handleInteraction, { once: true });
    window.addEventListener('touchstart', handleInteraction, { once: true });

    return () => {
      window.removeEventListener('mousemove', handleInteraction);
      window.removeEventListener('keydown', handleInteraction);
      window.removeEventListener('touchstart', handleInteraction);
    };
  }, []);

  // Anti-bot: Rate limiting
  const checkRateLimit = () => {
    try {
      const submissions = JSON.parse(localStorage.getItem('formSubmissionsGeneral') || '[]');
      const now = Date.now();
      const oneHour = 60 * 60 * 1000;

      // Filter submissions from the last hour
      const recentSubmissions = submissions.filter(time => now - time < oneHour);

      if (recentSubmissions.length >= 3) {
        return false; // Blocked
      }

      // Add current submission
      recentSubmissions.push(now);
      localStorage.setItem('formSubmissionsGeneral', JSON.stringify(recentSubmissions));
      return true;
    } catch (error) {
      return true; // If localStorage fails, allow submission
    }
  };

  const handleOnSubmit = async (e) => {
    e.preventDefault();
    const formButton = document.getElementById("button-send");
    const formInputs = document.getElementById("main-form");

    // ANTI-BOT VALIDATIONS

    // 1. Honeypot - if filled, it's a bot
    if (website.value !== "") {
      gracias(); // Show success but DON'T send
      return;
    }

    // 2. Minimum time - bots fill forms instantly
    const timeSinceLoad = (Date.now() - formLoadTime.current) / 1000;
    if (timeSinceLoad < 3) {
      gracias(); // Show success but DON'T send
      return;
    }

    // 3. Interaction - bots don't move the mouse
    if (!hasInteracted) {
      gracias(); // Show success but DON'T send
      return;
    }

    // 4. Rate limiting - max 3 submissions per hour
    if (!checkRateLimit()) {
      formButton.innerHTML = "DEMASIADOS INTENTOS";
      formButton.classList.add("btn-fill");
      validate();
      return;
    }

    // NORMAL VALIDATIONS

    if (name.value === "" || email.value === "" || message.value === "") {
      formButton.innerHTML = "INGRESE INFORMACIÓN";
      const inputs = formInputs.elements;

      if (name.value === "") inputs["name"].classList.add("btn-fill");
      if (email.value === "") inputs["email"].classList.add("btn-fill");
      if (message.value === "") inputs["message"].classList.add("btn-fill");
      formButton.classList.add("btn-fill");
      validate();
    } else {
      sendForm();
    }
  };

  const sendForm = async () => {
    const formData = new FormData();
    formData.append("name", name.value);
    formData.append("email", email.value);
    formData.append("phone", phone.value);
    formData.append("mensaje", message.value);
    formData.append("languaje", "es");
    formData.append("section", "contact-caribe");

    fetch(`${process.env.REACT_APP_URL}/send-contact-us`, {
      method: "POST",
      body: formData,
    });

    const dataEmail = {
      name: name.value,
      email: email.value,
      message: message.value,
      section: "contactHome-caribe",
    };

    fetch(`${process.env.REACT_APP_SEND_EMAIL_HORIZONTAL}/main-email`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataEmail),
    }).catch((error) => {
      console.log(error);
    });

    gracias();
  };

  const gracias = () => {
    const formButton = document.getElementById("button-send");

    formButton.innerHTML = "GRACIAS";
    formButton.classList.add("btn-thanks");
    resetForm();
  };

  const resetForm = () => {
    const formButton = document.getElementById("button-send");
    const formInputs = document.getElementById("main-form");

    setTimeout(() => {
      const inputs = formInputs.elements;

      formButton.innerHTML = "ENVIAR";
      formButton.classList.remove("btn-thanks");
      inputs["name"].value = "";
      inputs["email"].value = "";
      inputs["phone"].value = "";
      inputs["message"].value = "";
    }, 3000);
  };

  const validate = () => {
    const formButton = document.getElementById("button-send");
    const formInputs = document.getElementById("main-form");

    setTimeout(() => {
      const inputs = formInputs.elements;

      formButton.innerHTML = "ENVIAR";
      formButton.classList.remove("btn-fill");
      inputs["name"].classList.remove("btn-fill");
      inputs["email"].classList.remove("btn-fill");
      inputs["message"].classList.remove("btn-fill");
    }, 3000);
  };

  return (
    <div className="GeneralContact">
      <div className="container">
        <div className="row no-gutters">
          <div className="col-xs-12 text-center">
            <h1>CONTÁCTANOS</h1>
          </div>
        </div>
        <div className="row no-gutters">
          <div className="col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2 text-justify">
            <p>
              Por favor complete el siguiente formulario o comuníquese con nosotros por correo electrónico a{" "}
              <a href="mailto: caribe@la-leyenda.com" className="caribe-link">
                caribe@la-leyenda.com
              </a>
            </p>
            <form id="main-form" className="contact-form" onSubmit={(e) => handleOnSubmit(e)}>
              <input type="text" name="name" placeholder="NOMBRE*" {...name} />
              <input type="email" name="email" placeholder="EMAIL*" {...email} />
              <input type="text" name="phone" placeholder="TELÉFONO" {...phone} />
              <textarea name="message" placeholder="MENSAJE*" cols="30" rows="10" {...message}></textarea>

              {/* HONEYPOT - Invisible for humans */}
              <input
                type="text"
                name="website"
                placeholder="Website"
                {...website}
                style={{
                  position: 'absolute',
                  left: '-9999px',
                  width: '1px',
                  height: '1px'
                }}
                tabIndex="-1"
                autoComplete="off"
              />

              <button id="button-send" type="submit">
                ENVIAR
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
